// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media only screen and (max-width: 1000px)
{
    .colsm{
        /* width: auto;
        height: auto;
        display: block; */
    /* min-width: 0; */
    flex-basis: 0;
    }
    .PageDesc
    {
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: white;
    }
    .btn-row-resp{
        display: block;
        flex-direction: column;
        width: 200px;
        height: auto;
        align-items: center;
        justify-content: center;
        /* margin-left: 10%;
        margin-top: 5em; */
    }
    .compass-image{
        width: 100%;
        height: auto;
    }
    .compass-image img{
        width: 100%;
        height: auto;
    }
    .benefit-detail-background-resp{
        height: 100%;
    }
    .benefit-resp2{
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 10vh;
        width:90%;
        float: right;
    } 
    .benefit-resp-text{
        left: 10vh;
        margin-left: 0vh;
        width: 19vh;
        font-size: 15px;
        color: rgb(114, 199, 82);
        text-align: center;
        font-weight: bolder;
    }
    .imgbene-resp{
        /* width: 90%;  */
        display: inline-flex;
        width: 92%;
        height: -webkit-fill-available;
    }
    .benefit-resp{
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width:90%;
        float: right;
    }
    .arrow-resp{
        margin-left: 0vh;
    }
    .respon{
        /* flex-direction: column;
        align-items: center;
        justify-content: center; */

    }
    .section
    {
        flex-direction: column;
    }
    .course-structure{
        flex-direction: column;
    }
    .MathPortalBackground{

        height: auto;
    }
  
    .modules{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .small-box{
        /* display: flex;
        flex-direction: column; */
        margin-top: 5vh;
    }
    .large-box{
        
        display: flex;
        flex-direction: column;
        margin-top: 15vh;
        width: auto;
    }
    .section-left
    {
        flex-direction: column;
    }
    .Text-small
    {
        text-align: center;
        position: relative;
    }
    
    .Text-big
    {
        text-align: center;
    }
    .benefit-img{
        width: 100%;
        height: 15vh;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .benefitLink{
        width: 85%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .highlightTitleSection{
        margin-left: 1em;
    }
    .background{
        height: auto;
    padding-bottom: 10vh;
    }
    .arrowRespFont
    {
        font-size: xxx-large;
    }
    .col-md-2
    {
        width: 50%;
    }
  /* Change the width of the three columns to 100%
  (to stack horizontally on small screens) */

    .columns {
      width: 100%;
    }
    .IntroDesc
    {
        width: 75%;
    }
    .IntroImages img{
        width: 50vw;
        height: 40vw;
    }
    .IntroGif{
        width: 100vw !important;
        height: 38vh !important;
    }

    .portalIntro
    {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-self: center;
    }
    .portalRespPara
    {
        width: 115%;
        margin-left: 0;
        padding-left: 0;
    }
    .portalRespBullets
    {
        margin: 0;
    }
    .teacherTestimonal
    {
        flex-direction: column;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2vh;
    }
    .testimonalBox1,.testimonalBox2{
        width: 50%;
        margin: 1vh;
        height: 30vh;
    }
    .kidSchool
    {
        height: auto;
    }
    .CEOMsg p{
        width: 100%;
        /* margin-left:15%; */
        padding-left: 0;
    }
    .footerText{
        margin-top: 0;
        width: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: justify;
    }
    .footerText p{
        color: gray;
    }
    .footerContent{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-bottom: 2vh;
    }
    .footerLinksSection
    {
        margin-top: 5%;
        display: flex;
        flex-wrap: wrap;
        height: auto;
        width: 100%;
        padding-top: 8vh;
    }
    .footerLinks,.footerLinks1,.footerLinks2
    {
        margin-top: 10vh;
        margin-left: 3%;
        margin-right: 3%;
        width: 44%;
    }
}


`, "",{"version":3,"sources":["webpack://./src/MyComponents/MathPortal/MathPortalResponsive.css"],"names":[],"mappings":";AACA;;IAEI;QACI;;yBAEiB;IACrB,kBAAkB;IAClB,aAAa;IACb;IACA;;QAEI,mBAAmB;QACnB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,YAAY;IAChB;IACA;QACI,cAAc;QACd,sBAAsB;QACtB,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB;0BACkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;QACjB,SAAS;QACT,YAAY;IAChB;IACA;QACI,UAAU;QACV,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,wBAAwB;QACxB,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,UAAU;QACV,8BAA8B;IAClC;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,YAAY;IAChB;IACA;QACI,gBAAgB;IACpB;IACA;QACI;;kCAE0B;;IAE9B;IACA;;QAEI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;;QAEI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI;iCACyB;QACzB,eAAe;IACnB;IACA;;QAEI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,WAAW;IACf;IACA;;QAEI,sBAAsB;IAC1B;IACA;;QAEI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,6BAA6B;IACjC;IACA;QACI,UAAU;QACV,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,6BAA6B;IACjC;IACA;QACI,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB,oBAAoB;IACpB;IACA;;QAEI,oBAAoB;IACxB;IACA;;QAEI,UAAU;IACd;EACF;4CAC0C;;IAExC;MACE,WAAW;IACb;IACA;;QAEI,UAAU;IACd;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,uBAAuB;QACvB,uBAAuB;IAC3B;;IAEA;;QAEI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,oBAAoB;IACxB;IACA;;QAEI,WAAW;QACX,cAAc;QACd,eAAe;IACnB;IACA;;QAEI,SAAS;IACb;IACA;;QAEI,sBAAsB;QACtB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;IAChB;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;IAChB;IACA;;QAEI,YAAY;IAChB;IACA;QACI,WAAW;QACX,qBAAqB;QACrB,eAAe;IACnB;IACA;QACI,aAAa;QACb,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;IACvB;IACA;;QAEI,cAAc;QACd,aAAa;QACb,eAAe;QACf,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;IACA;;QAEI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,UAAU;IACd;AACJ","sourcesContent":["\n@media only screen and (max-width: 1000px)\n{\n    .colsm{\n        /* width: auto;\n        height: auto;\n        display: block; */\n    /* min-width: 0; */\n    flex-basis: 0;\n    }\n    .PageDesc\n    {\n        align-items: center;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        color: white;\n    }\n    .btn-row-resp{\n        display: block;\n        flex-direction: column;\n        width: 200px;\n        height: auto;\n        align-items: center;\n        justify-content: center;\n        /* margin-left: 10%;\n        margin-top: 5em; */\n    }\n    .compass-image{\n        width: 100%;\n        height: auto;\n    }\n    .compass-image img{\n        width: 100%;\n        height: auto;\n    }\n    .benefit-detail-background-resp{\n        height: 100%;\n    }\n    .benefit-resp2{\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        margin-left: 10vh;\n        width:90%;\n        float: right;\n    } \n    .benefit-resp-text{\n        left: 10vh;\n        margin-left: 0vh;\n        width: 19vh;\n        font-size: 15px;\n        color: rgb(114, 199, 82);\n        text-align: center;\n        font-weight: bolder;\n    }\n    .imgbene-resp{\n        /* width: 90%;  */\n        display: inline-flex;\n        width: 92%;\n        height: -webkit-fill-available;\n    }\n    .benefit-resp{\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width:90%;\n        float: right;\n    }\n    .arrow-resp{\n        margin-left: 0vh;\n    }\n    .respon{\n        /* flex-direction: column;\n        align-items: center;\n        justify-content: center; */\n\n    }\n    .section\n    {\n        flex-direction: column;\n    }\n    .course-structure{\n        flex-direction: column;\n    }\n    .MathPortalBackground{\n\n        height: auto;\n    }\n  \n    .modules{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n    .small-box{\n        /* display: flex;\n        flex-direction: column; */\n        margin-top: 5vh;\n    }\n    .large-box{\n        \n        display: flex;\n        flex-direction: column;\n        margin-top: 15vh;\n        width: auto;\n    }\n    .section-left\n    {\n        flex-direction: column;\n    }\n    .Text-small\n    {\n        text-align: center;\n        position: relative;\n    }\n    \n    .Text-big\n    {\n        text-align: center;\n    }\n    .benefit-img{\n        width: 100%;\n        height: 15vh;\n        display: flex;\n        align-items: center;\n        justify-content: space-around;\n    }\n    .benefitLink{\n        width: 85%;\n        height: auto;\n        display: flex;\n        align-items: center;\n        justify-content: space-around;\n    }\n    .highlightTitleSection{\n        margin-left: 1em;\n    }\n    .background{\n        height: auto;\n    padding-bottom: 10vh;\n    }\n    .arrowRespFont\n    {\n        font-size: xxx-large;\n    }\n    .col-md-2\n    {\n        width: 50%;\n    }\n  /* Change the width of the three columns to 100%\n  (to stack horizontally on small screens) */\n\n    .columns {\n      width: 100%;\n    }\n    .IntroDesc\n    {\n        width: 75%;\n    }\n    .IntroImages img{\n        width: 50vw;\n        height: 40vw;\n    }\n    .IntroGif{\n        width: 100vw !important;\n        height: 38vh !important;\n    }\n\n    .portalIntro\n    {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-self: center;\n    }\n    .portalRespPara\n    {\n        width: 115%;\n        margin-left: 0;\n        padding-left: 0;\n    }\n    .portalRespBullets\n    {\n        margin: 0;\n    }\n    .teacherTestimonal\n    {\n        flex-direction: column;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 2vh;\n    }\n    .testimonalBox1,.testimonalBox2{\n        width: 50%;\n        margin: 1vh;\n        height: 30vh;\n    }\n    .kidSchool\n    {\n        height: auto;\n    }\n    .CEOMsg p{\n        width: 100%;\n        /* margin-left:15%; */\n        padding-left: 0;\n    }\n    .footerText{\n        margin-top: 0;\n        width: 80%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        text-align: justify;\n    }\n    .footerText p{\n        color: gray;\n    }\n    .footerContent{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        padding-bottom: 2vh;\n    }\n    .footerLinksSection\n    {\n        margin-top: 5%;\n        display: flex;\n        flex-wrap: wrap;\n        height: auto;\n        width: 100%;\n        padding-top: 8vh;\n    }\n    .footerLinks,.footerLinks1,.footerLinks2\n    {\n        margin-top: 10vh;\n        margin-left: 3%;\n        margin-right: 3%;\n        width: 44%;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
